var lib_core = require("lib-core");
var _        = require('underscore');

var TrayView         = require("./trayView.js");
var TrayModel        = require("./trayModel.js");
var TrayStateMachine = require("./trayStateMachine.js");

var TabController = require("./../tab/tabController.js");
var AbstractEditorController = require("./../../abstract/abstractEditorController.js");
var MasterController = require("../master/masterController.js");

var TrayController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        initial_height: 500,
        minimum_height: 300
    });
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    this.toggleButton = null;

    lib_core.GuiEvents.addEvents({
        UI_TRAY_TOGGLE:                {id: 'ui_tray_01', name: "UI_TRAY_TOGGLE" },
        UI_TRAY_DRAG_MOUSE_DOWN:       {id: 'ui_tray_02', name: "UI_TRAY_DRAG_MOUSE_DOWN" },
        UI_TRAY_BUTTON:                {id: 'ui_tray_03', name: "UI_TRAY_BUTTON" }
    });
};
lib_core.inherit(TrayController, lib_core.Controller);
TrayController.inject = {
    tabController : TabController,
    abstractEditorController : AbstractEditorController,
    masterController : MasterController
};

module.exports = TrayController;

TrayController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    if(this.configuration.height){
        this.getModel().height(this.configuration.height);
    }
};

TrayController.prototype.createView = function () {
    var toggleButton = null;
    if(this.configuration.button) {
        toggleButton = this.tabController.getView().registerButton({
            name: this.configuration.button.name,
            title: this.configuration.button.title,
            sortOrder: 2,
            eventType: lib_core.GuiEvents.UI_TRAY_TOGGLE,
            scope: this.getModel().scope(),
            style: {
                icon: this.configuration.button.style.icon
            },
            group: "toggle buttons"
        });
    }

    return new TrayView(this.getModel(), this.getStatemachine(), this.parent().getView(), this.masterController ? this.masterController.getView() : null, toggleButton,
            this.rootStateMachine, this.parent().getModel(), this.configuration);
};

TrayController.prototype.createModel = function () {
    return new TrayModel(this.configuration);
};

TrayController.prototype.createStateMachine = function () {
    return new TrayStateMachine(this.root, this.getModel(), this.parent().getModel());
};
